import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, ParamMap, UrlSegment } from "@angular/router";
import { Store } from "@ngrx/store";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { authActions } from "src/app/state/auth/auth.actions";

import * as authSelectors from "src/app/state/auth/auth.selector";
import * as routeSelectors from "src/app/state/route/route.selector";
import {settings} from "../../settings/settings";

@Component({
  selector: "binsta-login",
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: "./login.component.html",
  styleUrl: `./login.component.css`,
})
export class LoginComponent {
  email = "";
  password = "";
  error = this.store.select(authSelectors.selectAuthError);
  loading = this.store.select(authSelectors.selectAuthLoading);
  returnUrl = "";
  apiUrl:string;

  constructor(
    private store: Store,
    private route: ActivatedRoute,
  ) {
    let httpProto = "http"
    if (settings.apiTls) {
      httpProto = "https"
    }
    this.apiUrl = `${httpProto}://${settings.apiHost}:${settings.apiPort}`
    this.store.select(routeSelectors.selectQueryParams).subscribe((params) => {
      if(params && "returnUrl" in params) {
        this.returnUrl = params["returnUrl"];
      }
    });
  }

  async enter() {
    this.store.dispatch(
      authActions.loginStarted({
        username: this.email,
        password: this.password,
        returnUrl: this.returnUrl,
      }),
    );
  }
}
